import { render, staticRenderFns } from "./DocumentLinkSettings.vue?vue&type=template&id=81439088&"
import script from "./DocumentLinkSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentLinkSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports